import * as THREE from "three";
const pro = [
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  1,
  0.856167,
  0.182038,
  -0.038205,
  0.029342,
  0.955115,
  0.015544,
  -288e-5,
  -1563e-6,
  1.004443,
  0.734766,
  0.334872,
  -0.069637,
  0.05184,
  0.919198,
  0.028963,
  -4928e-6,
  -4209e-6,
  1.009137,
  0.630323,
  0.465641,
  -0.095964,
  0.069181,
  0.890046,
  0.040773,
  -6308e-6,
  -7724e-6,
  1.014032,
  0.539009,
  0.579343,
  -0.118352,
  0.082546,
  0.866121,
  0.051332,
  -7136e-6,
  -0.011959,
  1.019095,
  0.458064,
  0.679578,
  -0.137642,
  0.092785,
  0.846313,
  0.060902,
  -7494e-6,
  -0.016807,
  1.024301,
  0.38545,
  0.769005,
  -0.154455,
  0.100526,
  0.829802,
  0.069673,
  -7442e-6,
  -0.02219,
  1.029632,
  0.319627,
  0.849633,
  -0.169261,
  0.106241,
  0.815969,
  0.07779,
  -7025e-6,
  -0.028051,
  1.035076,
  0.259411,
  0.923008,
  -0.18242,
  0.110296,
  0.80434,
  0.085364,
  -6276e-6,
  -0.034346,
  1.040622,
  0.203876,
  0.990338,
  -0.194214,
  0.112975,
  0.794542,
  0.092483,
  -5222e-6,
  -0.041043,
  1.046265,
  0.152286,
  1.052583,
  -0.204868,
  0.114503,
  0.786281,
  0.099216,
  -3882e-6,
  -0.048116,
  1.051998
];
const deu = [
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  1,
  0.866435,
  0.177704,
  -0.044139,
  0.049567,
  0.939063,
  0.01137,
  -3453e-6,
  7233e-6,
  0.99622,
  0.760729,
  0.319078,
  -0.079807,
  0.090568,
  0.889315,
  0.020117,
  -6027e-6,
  0.013325,
  0.992702,
  0.675425,
  0.43385,
  -0.109275,
  0.125303,
  0.847755,
  0.026942,
  -795e-5,
  0.018572,
  0.989378,
  0.605511,
  0.52856,
  -0.134071,
  0.155318,
  0.812366,
  0.032316,
  -9376e-6,
  0.023176,
  0.9862,
  0.547494,
  0.607765,
  -0.155259,
  0.181692,
  0.781742,
  0.036566,
  -0.01041,
  0.027275,
  0.983136,
  0.498864,
  0.674741,
  -0.173604,
  0.205199,
  0.754872,
  0.039929,
  -0.011131,
  0.030969,
  0.980162,
  0.457771,
  0.731899,
  -0.18967,
  0.226409,
  0.731012,
  0.042579,
  -0.011595,
  0.034333,
  0.977261,
  0.422823,
  0.781057,
  -0.203881,
  0.245752,
  0.709602,
  0.044646,
  -0.011843,
  0.037423,
  0.974421,
  0.392952,
  0.82361,
  -0.216562,
  0.263559,
  0.69021,
  0.046232,
  -0.01191,
  0.040281,
  0.97163,
  0.367322,
  0.860646,
  -0.227968,
  0.280085,
  0.672501,
  0.047413,
  -0.01182,
  0.04294,
  0.968881
];
const tri = [
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  1,
  0.92667,
  0.092514,
  -0.019184,
  0.021191,
  0.964503,
  0.014306,
  8437e-6,
  0.054813,
  0.93675,
  0.89572,
  0.13333,
  -0.02905,
  0.029997,
  0.9454,
  0.024603,
  0.013027,
  0.104707,
  0.882266,
  0.905871,
  0.127791,
  -0.033662,
  0.026856,
  0.941251,
  0.031893,
  0.01341,
  0.148296,
  0.838294,
  0.948035,
  0.08949,
  -0.037526,
  0.014364,
  0.946792,
  0.038844,
  0.010853,
  0.193991,
  0.795156,
  1.017277,
  0.027029,
  -0.044306,
  -6113e-6,
  0.958479,
  0.047634,
  6379e-6,
  0.248708,
  0.744913,
  1.104996,
  -0.046633,
  -0.058363,
  -0.032137,
  0.971635,
  0.060503,
  1336e-6,
  0.317922,
  0.680742,
  1.193214,
  -0.109812,
  -0.083402,
  -0.058496,
  0.97941,
  0.079086,
  -2346e-6,
  0.403492,
  0.598854,
  1.257728,
  -0.139648,
  -0.118081,
  -0.078003,
  0.975409,
  0.102594,
  -3316e-6,
  0.501214,
  0.502102,
  1.278864,
  -0.125333,
  -0.153531,
  -0.084748,
  0.957674,
  0.127074,
  -989e-6,
  0.601151,
  0.399838,
  1.255528,
  -0.076749,
  -0.178779,
  -0.078411,
  0.930809,
  0.147602,
  4733e-6,
  0.691367,
  0.3039
];
const machado = {
  pro,
  deu,
  tri
};
let hotShaderMaterials = [];
window.__on_glsl_hmr_update = function(source2) {
  console.log("XXX");
  for (let mat of hotShaderMaterials) {
    console.log(mat.name);
    if (mat.name == source2.id) {
      mat.vertexShader = getStageSource(source2, "vertex");
      mat.fragmentShader = getStageSource(source2, "fragment");
      mat.needsUpdate = true;
      console.log("HMR:", mat.name);
    }
  }
};
function getStageSource(source2, stage) {
  let section = source2.sections.find((s) => s.stage == stage);
  return section ? section.text : null;
}
class HotShaderMaterial extends THREE.RawShaderMaterial {
  constructor({
    source: source2,
    ...parameters
  }) {
    super({
      ...parameters,
      name: source2.id,
      vertexShader: getStageSource(source2, "vertex"),
      fragmentShader: getStageSource(source2, "fragment")
    });
    hotShaderMaterials.push(this);
  }
}
function range(...args) {
  let lo, hi, step;
  if (args.length === 1) {
    lo = 0;
    hi = args[0];
    step = 1;
  } else if (args.length === 2) {
    lo = args[0];
    hi = args[1];
    step = 1;
  } else if (args.length === 3) {
    lo = args[0];
    hi = args[1];
    step = args[2];
  }
  const out = [];
  if (lo < hi && step > 0 || lo > hi && step < 0) {
    for (let i = lo; step < 0 ? i > hi : i < hi; i += step)
      out.push(i);
  }
  return out;
}
let source$8 = { "id": "src/shaders/three/cvd.glsl", "sections": [{ "stage": "vertex", "start": 2, "count": 9, "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\nuniform mat3 uMatTexCamera;\nvoid main() {\n    gl_Position = vec4(position, 1.0);\n    vCoord = (uMatTexCamera * vec3(uv, 1.0)).xy;\n}\n", "lines": ["attribute vec3 position;", "attribute vec2 uv;", "varying vec2 vCoord;", "uniform mat3 uMatTexCamera;", "void main() {", "    gl_Position = vec4(position, 1.0);", "    vCoord = (uMatTexCamera * vec3(uv, 1.0)).xy;", "}", ""] }, { "stage": "fragment", "start": 12, "count": 51, "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexCamera;\nuniform mat3 uMatCVD;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\nvoid main() {\n    vec2 uv = vCoord;\n    if (uv.x < 0.0 || uv.x > 1.0 ||\n        uv.y < 0.0 || uv.y > 1.0)\n    {\n        discard;\n    }\n\n    vec3 C = texture2D(uTexCamera, uv).rgb;\n    C = linearFromSRGB(C);\n    C *= uMatCVD;\n    C = sRGBFromLinear(C);\n    //C += vec3(uv, 0.0);\n    gl_FragColor = vec4(C, 1.0);\n}\n", "lines": ["precision highp float;", "varying vec2 vCoord;", "uniform sampler2D uTexCamera;", "uniform mat3 uMatCVD;", "", "float linearFromSRGB(float s) {", "    if (s < 0.04045) {", "        return s / 12.92;", "    } else {", "        return pow((s + 0.055) / 1.055, 2.4);", "    }", "}", "", "float sRGBFromLinear(float l) {", "    if (l < 0.0031308) {", "        return l * 12.92;", "    } else {", "        return 1.055 * pow(l, 1.0/2.4) - 0.055;", "    }", "}", "", "vec3 linearFromSRGB(vec3 sRGB) {", "    return vec3(", "        linearFromSRGB(sRGB[0]),", "        linearFromSRGB(sRGB[1]),", "        linearFromSRGB(sRGB[2]));", "}", "", "vec3 sRGBFromLinear(vec3 linear) {", "    return vec3(", "        sRGBFromLinear(linear[0]),", "        sRGBFromLinear(linear[1]),", "        sRGBFromLinear(linear[2]));", "}", "", "void main() {", "    vec2 uv = vCoord;", "    if (uv.x < 0.0 || uv.x > 1.0 ||", "        uv.y < 0.0 || uv.y > 1.0)", "    {", "        discard;", "    }", "", "    vec3 C = texture2D(uTexCamera, uv).rgb;", "    C = linearFromSRGB(C);", "    C *= uMatCVD;", "    C = sRGBFromLinear(C);", "    //C += vec3(uv, 0.0);", "    gl_FragColor = vec4(C, 1.0);", "}", ""] }] };
let source$7 = { "id": "src/shaders/three/blur.glsl", "sections": [{ "stage": "vertex", "start": 2, "count": 21, "text": "attribute vec3 position;\nattribute vec2 uv;\n\nvarying vec2 vCoord0;\nvarying vec4 vCoord1, vCoord2;\n\nuniform vec2 uSampleDelta;\n\nvoid main() {\n    const float o1 = 1.38462, o2 = 3.22702;\n    vCoord0 = uv;\n    vCoord1 = vec4(\n        uv - o1 * uSampleDelta,\n        uv + o1 * uSampleDelta);\n    vCoord2 = vec4(\n        uv - o2 * uSampleDelta,\n        uv + o2 * uSampleDelta);\n    //gl_Position = vec4(2.*(position - .5), 0., 1.);\n    gl_Position = vec4(position, 1.0);\n}\n", "lines": ["attribute vec3 position;", "attribute vec2 uv;", "", "varying vec2 vCoord0;", "varying vec4 vCoord1, vCoord2;", "", "uniform vec2 uSampleDelta;", "", "void main() {", "    const float o1 = 1.38462, o2 = 3.22702;", "    vCoord0 = uv;", "    vCoord1 = vec4(", "        uv - o1 * uSampleDelta,", "        uv + o1 * uSampleDelta);", "    vCoord2 = vec4(", "        uv - o2 * uSampleDelta,", "        uv + o2 * uSampleDelta);", "    //gl_Position = vec4(2.*(position - .5), 0., 1.);", "    gl_Position = vec4(position, 1.0);", "}", ""] }, { "stage": "fragment", "start": 24, "count": 33, "text": "precision highp float;\nvarying vec2 vCoord0;\nvarying vec4 vCoord1, vCoord2;\nuniform sampler2D uTexSource;\nuniform vec2 uNoiseShift;\n\nfloat random(vec3 c) {\n    float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));\n    return fract(512.0*j + 0.123);\n}\n\nfloat rand(vec2 n) { \n    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);\n}\n\nvoid main() {\n    const float w0 = 0.22702, w1 = 0.31622, w2 = 0.07027;\n    gl_FragColor = (\n        w0 * texture2D(uTexSource, vCoord0) +\n        w1 * (\n            texture2D(uTexSource, vCoord1.xy) +\n            texture2D(uTexSource, vCoord1.zw)) +\n        w2 * (\n            texture2D(uTexSource, vCoord2.xy) +\n            texture2D(uTexSource, vCoord2.zw)));\n\n#ifdef USE_NOISE\n    vec2 uv = gl_FragCoord.xy + uNoiseShift;\n    float n = 0.020 * (rand(uv) - 0.5);\n    gl_FragColor.rgb += vec3(n);\n#endif\n}\n", "lines": ["precision highp float;", "varying vec2 vCoord0;", "varying vec4 vCoord1, vCoord2;", "uniform sampler2D uTexSource;", "uniform vec2 uNoiseShift;", "", "float random(vec3 c) {", "    float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));", "    return fract(512.0*j + 0.123);", "}", "", "float rand(vec2 n) { ", "    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);", "}", "", "void main() {", "    const float w0 = 0.22702, w1 = 0.31622, w2 = 0.07027;", "    gl_FragColor = (", "        w0 * texture2D(uTexSource, vCoord0) +", "        w1 * (", "            texture2D(uTexSource, vCoord1.xy) +", "            texture2D(uTexSource, vCoord1.zw)) +", "        w2 * (", "            texture2D(uTexSource, vCoord2.xy) +", "            texture2D(uTexSource, vCoord2.zw)));", "", "#ifdef USE_NOISE", "    vec2 uv = gl_FragCoord.xy + uNoiseShift;", "    float n = 0.020 * (rand(uv) - 0.5);", "    gl_FragColor.rgb += vec3(n);", "#endif", "}", ""] }] };
let source$6 = { "id": "src/shaders/three/armd.glsl", "sections": [{ "stage": "vertex", "start": 2, "count": 9, "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n", "lines": ["attribute vec3 position;", "attribute vec2 uv;", "varying vec2 vCoord;", "", "void main() {", "    vCoord = uv;", "    gl_Position = vec4(position, 1.0);", "}", ""] }, { "stage": "fragment", "start": 12, "count": 83, "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\n\nuniform mat3 uMatCVD;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n\n    // scale around center by severity (splodge larger as severity -> 1)\n    vec2 Suv = mix(3.0, 1.5, uSeverity) * (uv - 0.5) + 0.5;\n    vec4 S = sampleSplodge(Suv);\n\n    // caclc distortion\n    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);\n    float x = clamp(3.0 * S.r, 0.0, 1.0);\n\n    // sample and blur by severity\n    vec3 C0 = mix(\n        texture2D(uTexSource0, uv + Duv).rgb,\n        texture2D(uTexSource2, uv + Duv).rgb,\n        uSeverity);\n\n    // blur again\n    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;\n    vec3 C = mix(C0, C1, x);\n\n    // blend to grey\n    float grey = mix(0.5, 0.0, uSeverity * uSeverity);\n    C = mix(C, vec3(grey), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));\n\n    // apply CVD\n    C = sRGBFromLinear(uMatCVD * linearFromSRGB(C));\n\n    gl_FragColor = vec4(C, 1.0);\n}\n", "lines": ["precision highp float;", "varying vec2 vCoord;", "uniform sampler2D uTexSource0;", "uniform sampler2D uTexSource1;", "uniform sampler2D uTexSource2;", "uniform sampler2D uTexSource3;", "uniform sampler2D uTexSource4;", "uniform sampler2D uTexSource5;", "uniform float uTime;", "uniform float uSeverity;", "", "uniform mat3 uMatCVD;", "", "float linearFromSRGB(float s) {", "    if (s < 0.04045) {", "        return s / 12.92;", "    } else {", "        return pow((s + 0.055) / 1.055, 2.4);", "    }", "}", "", "float sRGBFromLinear(float l) {", "    if (l < 0.0031308) {", "        return l * 12.92;", "    } else {", "        return 1.055 * pow(l, 1.0/2.4) - 0.055;", "    }", "}", "", "vec3 linearFromSRGB(vec3 sRGB) {", "    return vec3(", "        linearFromSRGB(sRGB[0]),", "        linearFromSRGB(sRGB[1]),", "        linearFromSRGB(sRGB[2]));", "}", "", "vec3 sRGBFromLinear(vec3 linear) {", "    return vec3(", "        sRGBFromLinear(linear[0]),", "        sRGBFromLinear(linear[1]),", "        sRGBFromLinear(linear[2]));", "}", "", "uniform sampler2D uTexSplodge;", "uniform mat3 uMatSplodge;", "", "vec4 sampleSplodge(vec2 uv) {", "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;", "    return texture2D(uTexSplodge, uv);", "}", "", "", "void main() {", "    vec2 uv = vCoord;", "", "    // scale around center by severity (splodge larger as severity -> 1)", "    vec2 Suv = mix(3.0, 1.5, uSeverity) * (uv - 0.5) + 0.5;", "    vec4 S = sampleSplodge(Suv);", "", "    // caclc distortion", "    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);", "    float x = clamp(3.0 * S.r, 0.0, 1.0);", "", "    // sample and blur by severity", "    vec3 C0 = mix(", "        texture2D(uTexSource0, uv + Duv).rgb,", "        texture2D(uTexSource2, uv + Duv).rgb,", "        uSeverity);", "", "    // blur again", "    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;", "    vec3 C = mix(C0, C1, x);", "", "    // blend to grey", "    float grey = mix(0.5, 0.0, uSeverity * uSeverity);", "    C = mix(C, vec3(grey), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));", "", "    // apply CVD", "    C = sRGBFromLinear(uMatCVD * linearFromSRGB(C));", "", "    gl_FragColor = vec4(C, 1.0);", "}", ""] }] };
let source$5 = { "id": "src/shaders/three/hemianopia.glsl", "sections": [{ "stage": "vertex", "start": 2, "count": 9, "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n", "lines": ["attribute vec3 position;", "attribute vec2 uv;", "varying vec2 vCoord;", "", "void main() {", "    vCoord = uv;", "    gl_Position = vec4(position, 1.0);", "}", ""] }, { "stage": "fragment", "start": 12, "count": 65, "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\n\nuniform sampler2D uTexNoise;\n\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\n\nfloat blend(float x, float m, float h) {\n    return smoothstep(m - h, m + h, x);\n}\n\nfloat rand(vec2 n) { \n    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);\n}\n\nvoid main() {\n    vec2 uv = vCoord;\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    //vec3 C1 = texture2D(uTexSource5, uv).rgb;\n    vec3 C;\n\n    {\n        float h = 0.1;\n        float m = 0.55;\n        float x = blend(vCoord.x, m, h);\n        vec3 gray = vec3(0.0);\n        \n        {\n            //vec2 uv = gl_FragCoord.xy * 0.002;\n            //gray += 0.005 * texture2D(uTexNoise, uv).rgb;\n        }\n        //gray += 0.05 * (rand(39.2*vCoord) - 0.5);\n\n        C = mix(C0, gray, blend(vCoord.x, 0.5, 0.010));\n        //C = mix(C0, C1, blend(vCoord.x, 0.9, 0.1));\n        //C = mix(C, gray, blend(vCoord.x, 0.4, 0.4));\n\n        /*\n        {\n            // spare central\n            float aspect = uResolution[0] / uResolution[1];\n            float h = mix(0.30, 0.00, uSeverity);\n            float m = mix(1.0, 0.0, sqrt(uSeverity));\n            vec2 uv = vCoord;\n            uv.x += 0.05;\n            float y = 0.0;\n            if (h > 0.0) {\n                y = 1.0 - smoothstep(-h, h, length((uv - 0.5) * vec2(aspect, 1.0)) - m);\n            }\n            C = mix(C, C0, y);\n        }\n        */\n    }\n\n    gl_FragColor = vec4(C, 1.0);\n}\n", "lines": ["precision highp float;", "varying vec2 vCoord;", "uniform sampler2D uTexSource0;", "uniform sampler2D uTexSource1;", "uniform sampler2D uTexSource2;", "uniform sampler2D uTexSource3;", "uniform sampler2D uTexSource4;", "uniform sampler2D uTexSource5;", "", "uniform sampler2D uTexNoise;", "", "uniform float uTime;", "uniform float uSeverity;", "uniform vec2 uResolution;", "", "float blend(float x, float m, float h) {", "    return smoothstep(m - h, m + h, x);", "}", "", "float rand(vec2 n) { ", "    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);", "}", "", "void main() {", "    vec2 uv = vCoord;", "    vec3 C0 = texture2D(uTexSource0, uv).rgb;", "    //vec3 C1 = texture2D(uTexSource5, uv).rgb;", "    vec3 C;", "", "    {", "        float h = 0.1;", "        float m = 0.55;", "        float x = blend(vCoord.x, m, h);", "        vec3 gray = vec3(0.0);", "        ", "        {", "            //vec2 uv = gl_FragCoord.xy * 0.002;", "            //gray += 0.005 * texture2D(uTexNoise, uv).rgb;", "        }", "        //gray += 0.05 * (rand(39.2*vCoord) - 0.5);", "", "        C = mix(C0, gray, blend(vCoord.x, 0.5, 0.010));", "        //C = mix(C0, C1, blend(vCoord.x, 0.9, 0.1));", "        //C = mix(C, gray, blend(vCoord.x, 0.4, 0.4));", "", "        /*", "        {", "            // spare central", "            float aspect = uResolution[0] / uResolution[1];", "            float h = mix(0.30, 0.00, uSeverity);", "            float m = mix(1.0, 0.0, sqrt(uSeverity));", "            vec2 uv = vCoord;", "            uv.x += 0.05;", "            float y = 0.0;", "            if (h > 0.0) {", "                y = 1.0 - smoothstep(-h, h, length((uv - 0.5) * vec2(aspect, 1.0)) - m);", "            }", "            C = mix(C, C0, y);", "        }", "        */", "    }", "", "    gl_FragColor = vec4(C, 1.0);", "}", ""] }] };
let source$4 = { "id": "src/shaders/three/cataracts.glsl", "sections": [{ "stage": "vertex", "start": 2, "count": 9, "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n", "lines": ["attribute vec3 position;", "attribute vec2 uv;", "varying vec2 vCoord;", "", "void main() {", "    vCoord = uv;", "    gl_Position = vec4(position, 1.0);", "}", ""] }, { "stage": "fragment", "start": 12, "count": 67, "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    vec3 C1 = texture2D(uTexSource5, uv).rgb;\n    vec3 C;\n\n    {\n        float aspect = uResolution[0] / uResolution[1];\n        float scale = 0.8;\n        uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;\n\n        vec2 d = vec2(1.0) / 512.0;\n\n        vec4 S = sampleSplodge(uv);\n\n        float x = S.r;\n\n        float blur = 1.0;\n        float glare = x;\n        float darken = 1.0;\n\n        x = clamp(2.0 * x * x, 0.9*uSeverity, 1.0);\n        //gl_FragColor = vec4(x); return;\n        C = mix(C0, C1, blur * x);\n        C *= mix(1.0, 0.8, darken * x);\n\n        // distort\n        float distort = 0.4 * uSeverity;\n        vec2 G = 0.2 * (S.gb - 0.5);\n        uv = vCoord + distort * G;\n        C = mix(\n            texture2D(uTexSource1, uv).rgb,\n            texture2D(uTexSource5, uv).rgb,\n            blur * x);\n\n        C += glare * mix(0.1, 1.0, x) * texture2D(uTexSource5, uv).rgb;\n\n        float decontrast = 0.9 * uSeverity;\n        C = mix(C, 1.2 * vec3(0.5, 0.45, 0.35), decontrast * x);\n        C = mix(C, vec3(0.55, 0.50, 0.48), 0.05);\n    }\n\n    gl_FragColor = vec4(C, 1.0);\n}\n", "lines": ["precision highp float;", "varying vec2 vCoord;", "uniform sampler2D uTexSource0;", "uniform sampler2D uTexSource1;", "uniform sampler2D uTexSource2;", "uniform sampler2D uTexSource3;", "uniform sampler2D uTexSource4;", "uniform sampler2D uTexSource5;", "uniform float uTime;", "uniform float uSeverity;", "uniform vec2 uResolution;", "", "uniform sampler2D uTexSplodge;", "uniform mat3 uMatSplodge;", "", "vec4 sampleSplodge(vec2 uv) {", "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;", "    return texture2D(uTexSplodge, uv);", "}", "", "", "void main() {", "    vec2 uv = vCoord;", "", "    vec3 C0 = texture2D(uTexSource0, uv).rgb;", "    vec3 C1 = texture2D(uTexSource5, uv).rgb;", "    vec3 C;", "", "    {", "        float aspect = uResolution[0] / uResolution[1];", "        float scale = 0.8;", "        uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;", "", "        vec2 d = vec2(1.0) / 512.0;", "", "        vec4 S = sampleSplodge(uv);", "", "        float x = S.r;", "", "        float blur = 1.0;", "        float glare = x;", "        float darken = 1.0;", "", "        x = clamp(2.0 * x * x, 0.9*uSeverity, 1.0);", "        //gl_FragColor = vec4(x); return;", "        C = mix(C0, C1, blur * x);", "        C *= mix(1.0, 0.8, darken * x);", "", "        // distort", "        float distort = 0.4 * uSeverity;", "        vec2 G = 0.2 * (S.gb - 0.5);", "        uv = vCoord + distort * G;", "        C = mix(", "            texture2D(uTexSource1, uv).rgb,", "            texture2D(uTexSource5, uv).rgb,", "            blur * x);", "", "        C += glare * mix(0.1, 1.0, x) * texture2D(uTexSource5, uv).rgb;", "", "        float decontrast = 0.9 * uSeverity;", "        C = mix(C, 1.2 * vec3(0.5, 0.45, 0.35), decontrast * x);", "        C = mix(C, vec3(0.55, 0.50, 0.48), 0.05);", "    }", "", "    gl_FragColor = vec4(C, 1.0);", "}", ""] }] };
let source$3 = { "id": "src/shaders/three/glaucoma.glsl", "sections": [{ "stage": "vertex", "start": 2, "count": 9, "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n", "lines": ["attribute vec3 position;", "attribute vec2 uv;", "varying vec2 vCoord;", "", "void main() {", "    vCoord = uv;", "    gl_Position = vec4(position, 1.0);", "}", ""] }, { "stage": "fragment", "start": 12, "count": 59, "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\nuniform int uEye;\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n    vec4 S;\n\n    {\n        vec2 uv2 = uv;\n        if (uEye == 1)\n            uv2.x = 1.0 - uv2.x;\n        S = sampleSplodge(uv2);\n    }\n\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n\n    vec2 uv2 = uv + 0.5 * (S.gb - 0.5);\n    vec3 C1 = texture2D(uTexSource5, uv2).rgb;\n    vec3 C;\n\n    C1 = mix(C1, vec3(0.45), mix(0.15, 0.80, uSeverity));\n\n    {\n        //float aspect = uResolution[0] / uResolution[1];\n        //float scale = 0.8;\n        //uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;\n        //vec2 d = vec2(1.0) / 512.0;\n        //vec4 S = texture2D(uTexSplodge, uv);\n        float scale = 2.2;\n        float x = min(1.0, S.r * scale);\n\n        vec2 d = uv - 0.5;\n        //x = max(x, uSeverity * length(d));\n        x = min(1.0, max(x, uSeverity * 3.0 * dot(d, d)));\n        C = mix(C0, C1, x);\n    }\n\n    gl_FragColor = vec4(C, 1.0);\n}\n", "lines": ["precision highp float;", "varying vec2 vCoord;", "uniform sampler2D uTexSource0;", "uniform sampler2D uTexSource1;", "uniform sampler2D uTexSource2;", "uniform sampler2D uTexSource3;", "uniform sampler2D uTexSource4;", "uniform sampler2D uTexSource5;", "uniform float uTime;", "uniform float uSeverity;", "uniform vec2 uResolution;", "uniform int uEye;", "", "uniform sampler2D uTexSplodge;", "uniform mat3 uMatSplodge;", "", "vec4 sampleSplodge(vec2 uv) {", "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;", "    return texture2D(uTexSplodge, uv);", "}", "", "", "void main() {", "    vec2 uv = vCoord;", "    vec4 S;", "", "    {", "        vec2 uv2 = uv;", "        if (uEye == 1)", "            uv2.x = 1.0 - uv2.x;", "        S = sampleSplodge(uv2);", "    }", "", "    vec3 C0 = texture2D(uTexSource0, uv).rgb;", "", "    vec2 uv2 = uv + 0.5 * (S.gb - 0.5);", "    vec3 C1 = texture2D(uTexSource5, uv2).rgb;", "    vec3 C;", "", "    C1 = mix(C1, vec3(0.45), mix(0.15, 0.80, uSeverity));", "", "    {", "        //float aspect = uResolution[0] / uResolution[1];", "        //float scale = 0.8;", "        //uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;", "        //vec2 d = vec2(1.0) / 512.0;", "        //vec4 S = texture2D(uTexSplodge, uv);", "        float scale = 2.2;", "        float x = min(1.0, S.r * scale);", "", "        vec2 d = uv - 0.5;", "        //x = max(x, uSeverity * length(d));", "        x = min(1.0, max(x, uSeverity * 3.0 * dot(d, d)));", "        C = mix(C0, C1, x);", "    }", "", "    gl_FragColor = vec4(C, 1.0);", "}", ""] }] };
let source$2 = { "id": "src/shaders/three/achromatopsia.glsl", "sections": [{ "stage": "vertex", "start": 2, "count": 9, "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n", "lines": ["attribute vec3 position;", "attribute vec2 uv;", "varying vec2 vCoord;", "", "void main() {", "    vCoord = uv;", "    gl_Position = vec4(position, 1.0);", "}", ""] }, { "stage": "fragment", "start": 12, "count": 99, "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\n\nvec3 scotopic(vec3 C) {\n    C = linearFromSRGB(C);\n\n    // convert to XYZ\n    vec3 XYZ = vec3(\n        0.5149 * C[0] + 0.3244 * C[1] + 0.1607 * C[2],\n        0.2654 * C[0] + 0.6704 * C[1] + 0.0642 * C[2],\n        0.0248 * C[0] + 0.1248 * C[1] + 0.8504 * C[2]);\n\n    // scotopic luminance (Larson et al)\n    float Ls = XYZ[1] * (\n        1.33 * (1.0 + (XYZ[1] + XYZ[2]) / XYZ[0]) - 1.68);\n\n    // regular luminance\n    //Ls = dot(C, vec3(0.2126, 0.7152, 0.0722));\n\n    vec3 blue = mix(vec3(1), vec3(.62, .6, 1.0), 0.5);\n    //C = Ls * 0.5 * vec3(1.0 - blue, 1.0 - blue, 1.0);\n    C = blue * vec3(Ls);\n    //C = mix(C0, C, 0.0);\n    C = sRGBFromLinear(C);\n    return C;\n}\n\nvoid main() {\n    vec2 uv = vCoord;\n\n    {\n        // nystagmus\n        float u = fract(3.0 * uTime);\n        float x = u < 0.8 ?\n            smoothstep(0.0, 0.9, u) : \n            smoothstep(1.0, 0.9, u);\n        //uv.x += 0.01 * sin(30.0 * uTime);\n        float travel = 0.03 * smoothstep(0.7, 1.0, uSeverity);\n        vec2 d = travel * normalize(vec2(1.0, 0.1));\n        //uv += d * mix(-1.0, 1.0, x);\n    }\n\n    vec3 Cblur = texture2D(uTexSource4, uv).rgb;\n    vec3 Csharp = texture2D(uTexSource3, uv).rgb;\n\n    Cblur = scotopic(Cblur);\n    Csharp = scotopic(Csharp);\n\n    vec3 diff = Csharp - Cblur;\n\n    //float gamma = mix(1.25, 1.1, smoothstep(0.9, 1.0, uSeverity));\n    float gamma = 1.25;\n    vec3 C = sign(diff) * pow(abs(diff), vec3(1.0/gamma));\n    C = Cblur + C;\n\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    C = mix(C0, C, smoothstep(0.0, 0.5, uSeverity));\n    gl_FragColor = vec4(C, 1.0);\n}\n", "lines": ["precision highp float;", "varying vec2 vCoord;", "uniform sampler2D uTexSource0;", "uniform sampler2D uTexSource1;", "uniform sampler2D uTexSource2;", "uniform sampler2D uTexSource3;", "uniform sampler2D uTexSource4;", "uniform sampler2D uTexSource5;", "uniform float uTime;", "uniform float uSeverity;", "", "float linearFromSRGB(float s) {", "    if (s < 0.04045) {", "        return s / 12.92;", "    } else {", "        return pow((s + 0.055) / 1.055, 2.4);", "    }", "}", "", "float sRGBFromLinear(float l) {", "    if (l < 0.0031308) {", "        return l * 12.92;", "    } else {", "        return 1.055 * pow(l, 1.0/2.4) - 0.055;", "    }", "}", "", "vec3 linearFromSRGB(vec3 sRGB) {", "    return vec3(", "        linearFromSRGB(sRGB[0]),", "        linearFromSRGB(sRGB[1]),", "        linearFromSRGB(sRGB[2]));", "}", "", "vec3 sRGBFromLinear(vec3 linear) {", "    return vec3(", "        sRGBFromLinear(linear[0]),", "        sRGBFromLinear(linear[1]),", "        sRGBFromLinear(linear[2]));", "}", "", "", "vec3 scotopic(vec3 C) {", "    C = linearFromSRGB(C);", "", "    // convert to XYZ", "    vec3 XYZ = vec3(", "        0.5149 * C[0] + 0.3244 * C[1] + 0.1607 * C[2],", "        0.2654 * C[0] + 0.6704 * C[1] + 0.0642 * C[2],", "        0.0248 * C[0] + 0.1248 * C[1] + 0.8504 * C[2]);", "", "    // scotopic luminance (Larson et al)", "    float Ls = XYZ[1] * (", "        1.33 * (1.0 + (XYZ[1] + XYZ[2]) / XYZ[0]) - 1.68);", "", "    // regular luminance", "    //Ls = dot(C, vec3(0.2126, 0.7152, 0.0722));", "", "    vec3 blue = mix(vec3(1), vec3(.62, .6, 1.0), 0.5);", "    //C = Ls * 0.5 * vec3(1.0 - blue, 1.0 - blue, 1.0);", "    C = blue * vec3(Ls);", "    //C = mix(C0, C, 0.0);", "    C = sRGBFromLinear(C);", "    return C;", "}", "", "void main() {", "    vec2 uv = vCoord;", "", "    {", "        // nystagmus", "        float u = fract(3.0 * uTime);", "        float x = u < 0.8 ?", "            smoothstep(0.0, 0.9, u) : ", "            smoothstep(1.0, 0.9, u);", "        //uv.x += 0.01 * sin(30.0 * uTime);", "        float travel = 0.03 * smoothstep(0.7, 1.0, uSeverity);", "        vec2 d = travel * normalize(vec2(1.0, 0.1));", "        //uv += d * mix(-1.0, 1.0, x);", "    }", "", "    vec3 Cblur = texture2D(uTexSource4, uv).rgb;", "    vec3 Csharp = texture2D(uTexSource3, uv).rgb;", "", "    Cblur = scotopic(Cblur);", "    Csharp = scotopic(Csharp);", "", "    vec3 diff = Csharp - Cblur;", "", "    //float gamma = mix(1.25, 1.1, smoothstep(0.9, 1.0, uSeverity));", "    float gamma = 1.25;", "    vec3 C = sign(diff) * pow(abs(diff), vec3(1.0/gamma));", "    C = Cblur + C;", "", "    vec3 C0 = texture2D(uTexSource0, uv).rgb;", "    C = mix(C0, C, smoothstep(0.0, 0.5, uSeverity));", "    gl_FragColor = vec4(C, 1.0);", "}", ""] }] };
let source$1 = { "id": "src/shaders/three/retinitis_pigmentosa.glsl", "sections": [{ "stage": "vertex", "start": 2, "count": 9, "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n", "lines": ["attribute vec3 position;", "attribute vec2 uv;", "varying vec2 vCoord;", "", "void main() {", "    vCoord = uv;", "    gl_Position = vec4(position, 1.0);", "}", ""] }, { "stage": "fragment", "start": 12, "count": 82, "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\nuniform int uEye;\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n    vec4 S;\n    {\n        //float scale = mix(0.0, 3.0, uSeverity * uSeverity * uSeverity);\n        //vec2 uv2 = scale * (uv - 0.5) + 0.5;\n        S = sampleSplodge(uv);\n    }\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    vec3 C1 = texture2D(uTexSource5, uv).rgb;\n\n    //float d = min(1.0, length(uv - 0.5) * mix(0.1, 2.8, uSeverity));\n    //C1 = mix(C1, vec3(0.45), d);\n\n    vec3 C = C0;\n    float x = 1.0 - S.g;\n\n    C = mix(C0, C1, 1.0 - S.r);\n    C = mix(C, vec3(0.0), 1.0 - S.g);\n\n    gl_FragColor = vec4(C, 1.0);\n\n    /*\n    vec2 uv = vCoord;\n    vec4 S;\n\n    {\n        vec2 uv2 = uv;\n        if (uEye == 1)\n            uv2.x = 1.0 - uv2.x;\n        S = texture2D(uTexSplodge, uv2);\n    }\n\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n\n    vec2 uv2 = uv + 0.5 * (S.gb - 0.5);\n    vec3 C1 = texture2D(uTexSource5, uv2).rgb;\n    vec3 C;\n\n    C1 = mix(C1, vec3(0.45), mix(0.75, 0.98, uSeverity));\n\n    {\n        //float aspect = uResolution[0] / uResolution[1];\n        //float scale = 0.8;\n        //uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;\n        //vec2 d = vec2(1.0) / 512.0;\n        //vec4 S = texture2D(uTexSplodge, uv);\n        float scale = 2.2;\n        float x = min(1.0, S.r * scale);\n\n        vec2 d = uv - 0.5;\n        //x = max(x, uSeverity * length(d));\n        x = min(1.0, max(x, uSeverity * 3.0 * dot(d, d)));\n        C = mix(C0, C1, x);\n    }\n\n    gl_FragColor = vec4(C, 1.0);\n    */\n}\n", "lines": ["precision highp float;", "varying vec2 vCoord;", "uniform sampler2D uTexSource0;", "uniform sampler2D uTexSource1;", "uniform sampler2D uTexSource2;", "uniform sampler2D uTexSource3;", "uniform sampler2D uTexSource4;", "uniform sampler2D uTexSource5;", "uniform float uTime;", "uniform float uSeverity;", "uniform vec2 uResolution;", "uniform int uEye;", "", "uniform sampler2D uTexSplodge;", "uniform mat3 uMatSplodge;", "", "vec4 sampleSplodge(vec2 uv) {", "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;", "    return texture2D(uTexSplodge, uv);", "}", "", "", "void main() {", "    vec2 uv = vCoord;", "    vec4 S;", "    {", "        //float scale = mix(0.0, 3.0, uSeverity * uSeverity * uSeverity);", "        //vec2 uv2 = scale * (uv - 0.5) + 0.5;", "        S = sampleSplodge(uv);", "    }", "    vec3 C0 = texture2D(uTexSource0, uv).rgb;", "    vec3 C1 = texture2D(uTexSource5, uv).rgb;", "", "    //float d = min(1.0, length(uv - 0.5) * mix(0.1, 2.8, uSeverity));", "    //C1 = mix(C1, vec3(0.45), d);", "", "    vec3 C = C0;", "    float x = 1.0 - S.g;", "", "    C = mix(C0, C1, 1.0 - S.r);", "    C = mix(C, vec3(0.0), 1.0 - S.g);", "", "    gl_FragColor = vec4(C, 1.0);", "", "    /*", "    vec2 uv = vCoord;", "    vec4 S;", "", "    {", "        vec2 uv2 = uv;", "        if (uEye == 1)", "            uv2.x = 1.0 - uv2.x;", "        S = texture2D(uTexSplodge, uv2);", "    }", "", "    vec3 C0 = texture2D(uTexSource0, uv).rgb;", "", "    vec2 uv2 = uv + 0.5 * (S.gb - 0.5);", "    vec3 C1 = texture2D(uTexSource5, uv2).rgb;", "    vec3 C;", "", "    C1 = mix(C1, vec3(0.45), mix(0.75, 0.98, uSeverity));", "", "    {", "        //float aspect = uResolution[0] / uResolution[1];", "        //float scale = 0.8;", "        //uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;", "        //vec2 d = vec2(1.0) / 512.0;", "        //vec4 S = texture2D(uTexSplodge, uv);", "        float scale = 2.2;", "        float x = min(1.0, S.r * scale);", "", "        vec2 d = uv - 0.5;", "        //x = max(x, uSeverity * length(d));", "        x = min(1.0, max(x, uSeverity * 3.0 * dot(d, d)));", "        C = mix(C0, C1, x);", "    }", "", "    gl_FragColor = vec4(C, 1.0);", "    */", "}", ""] }] };
let source = { "id": "src/shaders/three/diabetic_retinopathy.glsl", "sections": [{ "stage": "vertex", "start": 2, "count": 9, "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n", "lines": ["attribute vec3 position;", "attribute vec2 uv;", "varying vec2 vCoord;", "", "void main() {", "    vCoord = uv;", "    gl_Position = vec4(position, 1.0);", "}", ""] }, { "stage": "fragment", "start": 12, "count": 122, "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\nuniform int uEye;\n\nuniform mat3 uMatCVD;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n\n    {\n        //vec4 S = texture2D(uTexSplodge, uv);\n        //gl_FragColor = vec4(vec3(S.r), 1.0);\n\n        //vec3 C = texture2D(uTexSource4, uv).rgb;\n        //gl_FragColor = vec4(C, 1.0);\n\n        //return;\n    }\n\n    vec4 S = sampleSplodge(uv);\n\n    // calc distortion\n    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);\n    float x = clamp(S.r, 0.0, 1.0);\n\n    // sample and blur by severity\n    vec3 C0 = mix(\n        texture2D(uTexSource0, uv + Duv).rgb,\n        texture2D(uTexSource2, uv + Duv).rgb,\n        uSeverity);\n\n    // blur again\n    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;\n    vec3 C = mix(C0, C1, x);\n\n    // blend to grey\n    float g = 1.0 - max(0.95*S.r, max(S.g, S.b));\n    C = mix(C, vec3(g), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));\n\n    //vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);\n    //float x = clamp(3.0 * S.r, 0.0, 1.0);\n    //vec2 Duv = 0.1 * (S.gb - 0.5);\n\n    /*\n    vec3 C0 = mix(\n        texture2D(uTexSource0, uv).rgb,\n        texture2D(uTexSource3, uv + Duv).rgb,\n        uSeverity);\n\n    vec3 C1 = mix(\n        texture2D(uTexSource5, uv + Duv).rgb,\n        vec3(0.05),\n        uSeverity*uSeverity);\n        */\n\n    //float x = clamp(1.5 * S.r, 0.0, 1.0);\n    //vec3 C = mix(C0, C1, x);\n\n    //C = linearFromSRGB(C);\n    //C = uMatCVD * C;\n    //C = sRGBFromLinear(C);\n\n    //float d = min(1.0, length(uv - 0.5) * mix(0.1, 2.8, uSeverity));\n    //C1 = mix(C1, vec3(0.45), d);\n\n    //vec3 C = C0;\n    //float x = 1.0 - S.g;\n\n    //C = mix(C0, C1, 1.0 - S.r);\n    //C = mix(C, vec3(0.5), 1.0 - S.g);\n\n    gl_FragColor = vec4(C, 1.0);\n}\n", "lines": ["precision highp float;", "varying vec2 vCoord;", "uniform sampler2D uTexSource0;", "uniform sampler2D uTexSource1;", "uniform sampler2D uTexSource2;", "uniform sampler2D uTexSource3;", "uniform sampler2D uTexSource4;", "uniform sampler2D uTexSource5;", "uniform float uTime;", "uniform float uSeverity;", "uniform vec2 uResolution;", "uniform int uEye;", "", "uniform mat3 uMatCVD;", "", "float linearFromSRGB(float s) {", "    if (s < 0.04045) {", "        return s / 12.92;", "    } else {", "        return pow((s + 0.055) / 1.055, 2.4);", "    }", "}", "", "float sRGBFromLinear(float l) {", "    if (l < 0.0031308) {", "        return l * 12.92;", "    } else {", "        return 1.055 * pow(l, 1.0/2.4) - 0.055;", "    }", "}", "", "vec3 linearFromSRGB(vec3 sRGB) {", "    return vec3(", "        linearFromSRGB(sRGB[0]),", "        linearFromSRGB(sRGB[1]),", "        linearFromSRGB(sRGB[2]));", "}", "", "vec3 sRGBFromLinear(vec3 linear) {", "    return vec3(", "        sRGBFromLinear(linear[0]),", "        sRGBFromLinear(linear[1]),", "        sRGBFromLinear(linear[2]));", "}", "", "uniform sampler2D uTexSplodge;", "uniform mat3 uMatSplodge;", "", "vec4 sampleSplodge(vec2 uv) {", "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;", "    return texture2D(uTexSplodge, uv);", "}", "", "", "void main() {", "    vec2 uv = vCoord;", "", "    {", "        //vec4 S = texture2D(uTexSplodge, uv);", "        //gl_FragColor = vec4(vec3(S.r), 1.0);", "", "        //vec3 C = texture2D(uTexSource4, uv).rgb;", "        //gl_FragColor = vec4(C, 1.0);", "", "        //return;", "    }", "", "    vec4 S = sampleSplodge(uv);", "", "    // calc distortion", "    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);", "    float x = clamp(S.r, 0.0, 1.0);", "", "    // sample and blur by severity", "    vec3 C0 = mix(", "        texture2D(uTexSource0, uv + Duv).rgb,", "        texture2D(uTexSource2, uv + Duv).rgb,", "        uSeverity);", "", "    // blur again", "    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;", "    vec3 C = mix(C0, C1, x);", "", "    // blend to grey", "    float g = 1.0 - max(0.95*S.r, max(S.g, S.b));", "    C = mix(C, vec3(g), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));", "", "    //vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);", "    //float x = clamp(3.0 * S.r, 0.0, 1.0);", "    //vec2 Duv = 0.1 * (S.gb - 0.5);", "", "    /*", "    vec3 C0 = mix(", "        texture2D(uTexSource0, uv).rgb,", "        texture2D(uTexSource3, uv + Duv).rgb,", "        uSeverity);", "", "    vec3 C1 = mix(", "        texture2D(uTexSource5, uv + Duv).rgb,", "        vec3(0.05),", "        uSeverity*uSeverity);", "        */", "", "    //float x = clamp(1.5 * S.r, 0.0, 1.0);", "    //vec3 C = mix(C0, C1, x);", "", "    //C = linearFromSRGB(C);", "    //C = uMatCVD * C;", "    //C = sRGBFromLinear(C);", "", "    //float d = min(1.0, length(uv - 0.5) * mix(0.1, 2.8, uSeverity));", "    //C1 = mix(C1, vec3(0.45), d);", "", "    //vec3 C = C0;", "    //float x = 1.0 - S.g;", "", "    //C = mix(C0, C1, 1.0 - S.r);", "    //C = mix(C, vec3(0.5), 1.0 - S.g);", "", "    gl_FragColor = vec4(C, 1.0);", "}", ""] }] };
class MyTextureLoader extends THREE.Loader {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    let texture = new THREE.Texture();
    let loader = new THREE.ImageLoader(this.manager);
    loader.setCrossOrigin(this.crossOrigin);
    loader.setPath(this.path);
    let callback = (image) => {
      texture.image = image;
      texture.needsUpdate = true;
      if (onLoad) {
        onLoad({
          texture,
          image
        });
      }
    };
    loader.load(url, callback, onProgress, onError);
    return texture;
  }
}
const lerp = (a, b, u) => a + u * (b - a);
function getCvdMatrix(out, type, amount) {
  if (type == "none") {
    out.identity();
    return;
  }
  let numKeys = 11;
  let u = amount * (numKeys - 1);
  let i0 = Math.floor(u);
  let i1 = Math.min(numKeys - 1, i0 + 1);
  let uu = u - i0;
  let name = type.substr(0, 3);
  let src = machado[name];
  let sp0 = 9 * i0;
  let sp1 = 9 * i1;
  let matCVD = out.elements;
  for (let i = 0; i < 9; ++i) {
    matCVD[i] = lerp(
      src[sp0 + i],
      src[sp1 + i],
      uu
    );
  }
}
function createFullScreenQuad(material) {
  let geom = new THREE.BufferGeometry();
  geom.setAttribute(
    "position",
    new THREE.Float32BufferAttribute([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3)
  );
  geom.setAttribute(
    "uv",
    new THREE.Float32BufferAttribute([0, 2, 0, 0, 2, 0], 2)
  );
  return new THREE.Mesh(geom, material);
}
function createTarget(w, h) {
  return new THREE.WebGLRenderTarget(w, h, { depthBuffer: false });
}
function EyewareEffects({
  assets
}) {
  let rtBase = createTarget();
  let rtComp = createTarget();
  let textureLoader = new MyTextureLoader();
  let loadTexture = (name, options) => {
    let url = assets.textures[name];
    let texture = textureLoader.load(
      url,
      ({ texture: texture2, image }) => {
        texture2.aspect = image.width / image.height;
      },
      void 0,
      (err) => {
        console.warn(`EyewareEffects: error loading texture "${name}":`, url, err);
      }
    );
    if (options && options.repeat) {
      texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
    }
    return texture;
  };
  let textures = {
    macula: loadTexture("macula"),
    cataracts: loadTexture("cataracts"),
    glaucoma: range(5).map((i) => loadTexture(`glaucoma${i + 1}`)),
    tunnel: range(5).map((i) => loadTexture(`tunnel${i + 1}`)),
    camouflage: range(5).map((i) => loadTexture(`camouflage${i + 1}`)),
    noise: loadTexture("bluenoise", { repeat: true })
  };
  function createConditionMaterial({
    source: source2,
    uniforms
  }) {
    return new HotShaderMaterial({
      source: source2,
      uniforms: {
        uTexSource0: { value: new THREE.Texture() },
        uTexSource1: { value: new THREE.Texture() },
        uTexSource2: { value: new THREE.Texture() },
        uTexSource3: { value: new THREE.Texture() },
        uTexSource4: { value: new THREE.Texture() },
        uTexSource5: { value: new THREE.Texture() },
        uTexSplodge: { value: new THREE.Texture() },
        uTime: { value: 0 },
        uSeverity: { value: 0 },
        uResolution: { value: new THREE.Vector2() },
        uEye: { value: 0 },
        uMatCVD: { value: new THREE.Matrix3() },
        uMatSplodge: { value: new THREE.Matrix3() },
        ...uniforms
      }
    });
  }
  let materials = {
    cvd: new HotShaderMaterial({
      source: source$8,
      uniforms: {
        uTexCamera: { value: new THREE.Texture() },
        uMatTexCamera: { value: new THREE.Matrix3() },
        uMatCVD: { value: new THREE.Matrix3() }
      }
    }),
    blur: new HotShaderMaterial({
      source: source$7,
      uniforms: {
        uTexSource: { value: new THREE.Texture() },
        uSampleDelta: { value: new THREE.Vector2() },
        uNoiseShift: { value: new THREE.Vector2() }
      },
      defines: {
        //USE_NOISE: true,
      }
    }),
    armd: createConditionMaterial({
      source: source$6
    }),
    cataracts: createConditionMaterial({
      source: source$4
    }),
    glaucoma: createConditionMaterial({
      source: source$3
    }),
    "diabetic-retinopathy": createConditionMaterial({
      source
    }),
    "retinitis-pigmentosa": createConditionMaterial({
      source: source$1
    }),
    hemianopia: createConditionMaterial({
      source: source$5
    }),
    achromatopsia: createConditionMaterial({
      source: source$2
    })
  };
  let quadMesh = createFullScreenQuad();
  let quadCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
  let cameraMatrix4 = new THREE.Matrix4();
  function renderQuad(renderer, material) {
    quadMesh.material = material;
    renderer.render(quadMesh, quadCamera);
  }
  function Level(index) {
    this.index = index;
    this.targets = [
      createTarget(),
      createTarget()
    ];
  }
  let numLevels = 5;
  let levels = range(numLevels).map((index) => new Level(index));
  new THREE.Vector2();
  let time0;
  let targetAspect = 1;
  function reallocTargets(renderer, mode) {
    let { width, height } = renderer.domElement;
    if (mode == "stereo")
      width /= 2;
    width = Math.floor(width);
    height = Math.floor(height);
    targetAspect = width / height;
    if (rtBase && rtBase.width === width && rtBase.height === height) {
      return;
    }
    console.log("realloc[%d]: %dx%d", 0, width, height);
    rtBase.setSize(width, height);
    rtComp.setSize(width, height);
    const baseShift = 1;
    levels.forEach((level, i) => {
      let shift = baseShift + i;
      let w = width >> shift;
      let h = height >> shift;
      level.targets.forEach((target) => target.setSize(w, h));
      console.log("realloc[%d]: %dx%d", 1 + i, w, h);
    });
  }
  function getBlurTexture(index) {
    if (index === 0)
      return rtBase.texture;
    else
      return levels[index - 1].targets[1].texture;
  }
  function renderBlur(renderer, sourceTexture) {
    let writeTarget, readTarget;
    {
      let { cvd: material } = materials;
      material.uniforms.uTexCamera.value = sourceTexture;
      material.uniforms.uMatTexCamera.value.copy(sourceTexture.matrix);
      material.uniforms.uMatCVD.value.identity();
      material.uniformsNeedUpdate = true;
      renderer.setRenderTarget(rtBase);
      renderQuad(renderer, material);
      writeTarget = levels[0].targets[1];
      renderer.setRenderTarget(writeTarget);
      renderQuad(renderer, material);
    }
    {
      let { blur: material } = materials;
      readTarget = writeTarget;
      for (let i = 0; i < numLevels; ++i) {
        let level = levels[i];
        for (let j = 0; j < 2; ++j) {
          let horz = j === 0 ? 1 : 0;
          let vert = 1 - horz;
          material.uniforms.uSampleDelta.value.set(
            horz / (readTarget.width - 1),
            vert / (readTarget.height - 1)
          );
          material.uniforms.uNoiseShift.value.set(
            Math.random(),
            Math.random()
          );
          material.uniforms.uTexSource.value = readTarget.texture;
          material.uniformsNeedUpdate = true;
          writeTarget = level.targets[j];
          renderer.setRenderTarget(writeTarget);
          renderQuad(renderer, material);
          readTarget = writeTarget;
        }
      }
    }
  }
  function timeNow() {
    return performance.now() * 1e-3;
  }
  function updateTime() {
    if (time0 === void 0) {
      time0 = timeNow();
    }
    return timeNow - time0;
  }
  let validConditions = [
    "none",
    "protanopia",
    "deuteranopia",
    "tritanopia",
    "achromatopsia",
    "hemianopia",
    "cataracts",
    "glaucoma",
    "retinitis-pigmentosa",
    "armd",
    "diabetic-retinopathy"
  ];
  function render({
    renderer,
    camera,
    condition = "none",
    severity = 5,
    mode = "mono",
    scale = [1, 1],
    blur = 0
  }) {
    let time = updateTime();
    reallocTargets(renderer, mode);
    if (!validConditions.includes(condition)) {
      console.warn('EyewareEffects: bad condition "%s"', condition);
      return;
    }
    severity = Math.floor(severity);
    if (severity < 1 || severity > 5) {
      console.warn('EyewareEffects: bad severity "%d"', severity);
      return;
    }
    let cameraTexture = camera.backgroundTexture;
    {
      cameraMatrix4.fromArray(
        camera.pipeline.cameraFrameTextureMatrix(
          rtComp.width,
          rtComp.height,
          false
        )
      );
      let { matrix } = cameraTexture;
      matrix.setFromMatrix4(cameraMatrix4);
      matrix.elements[6] = cameraMatrix4.elements[12];
      matrix.elements[7] = cameraMatrix4.elements[13];
      matrix.elements[8] = 1;
    }
    renderBlur(renderer, cameraTexture);
    if (condition == "protanopia" || condition == "deuteranopia" || condition == "tritanopia" || condition == "none") {
      let material = materials.cvd;
      if (condition == "none") {
        material.uniforms.uMatCVD.value.identity();
      } else {
        getCvdMatrix(material.uniforms.uMatCVD.value, condition, severity / 5);
      }
      material.uniforms.uTexCamera.value = getBlurTexture(0);
      material.uniforms.uMatTexCamera.value.identity();
      material.uniformsNeedUpdate = true;
      renderer.setRenderTarget(rtComp);
      renderQuad(renderer, material);
    } else {
      let material = materials[condition];
      material.uniforms.uMatCVD.value.identity();
      let splodge;
      if (condition == "cataracts") {
        splodge = textures.cataracts;
      } else if (condition == "glaucoma") {
        splodge = textures.glaucoma[severity - 1];
      } else if (condition == "retinitis-pigmentosa") {
        splodge = textures.tunnel[severity - 1];
      } else if (condition == "armd") {
        splodge = textures.macula;
        getCvdMatrix(material.uniforms.uMatCVD.value, "tritanopia", 0.5 * severity / 5);
      } else if (condition == "diabetic-retinopathy") {
        splodge = textures.camouflage[severity - 1];
        getCvdMatrix(material.uniforms.uMatCVD.value, "tritanopia", 0.5 * severity / 5);
      }
      if (splodge) {
        material.uniforms.uTexSplodge.value = splodge;
        let e = material.uniforms.uMatSplodge.value.elements;
        let sourceAspect = splodge.aspect ?? 1;
        let vScale = sourceAspect / targetAspect;
        e[4] = vScale;
        e[7] = 0.5 * (1 - vScale);
      }
      for (let i = 0; i < 6; ++i) {
        let name = `uTexSource${i}`;
        material.uniforms[name].value = getBlurTexture(i);
      }
      material.uniforms.uTime.value = time;
      material.uniforms.uSeverity.value = severity / 5;
      material.uniforms.uResolution.value.set(rtComp.width, rtComp.height);
      material.uniforms.uEye.value = 0;
      renderer.setRenderTarget(rtComp);
      renderQuad(renderer, material);
    }
    renderer.setRenderTarget(null);
  }
  return Object.assign(new.target ? this : {}, {
    render,
    get texture() {
      return rtComp.texture;
    },
  });
}
export {
  EyewareEffects as default
};